import { gridGap, stacked, grid, gridBorder } from "@universityofmaryland/web-elements-library/layout";
const gridLayout = {
  create: (options) => {
    const { columns = 3 } = options;
    return grid({ columns, minHeight: "560px" });
  },
  getId: () => "umd-grid-layout-container"
};
const gridGapLayout = {
  create: (options) => {
    const { columns = 3 } = options;
    return gridGap({ columns });
  },
  getId: () => "umd-grid-gap-layout-container"
};
const gridBorderLayout = {
  create: (options) => {
    const { columns = 3, isThemeDark = false } = options;
    return gridBorder({ columns, isThemeDark });
  },
  getId: () => "umd-grid-border-layout-container"
};
const stackedLayout = {
  create: (options) => {
    const { isThemeDark, showDividers = true } = options;
    return stacked({ isThemeDark, showDividers, gap: "0" });
  },
  getId: () => "umd-stacked-layout-container"
};
export {
  gridBorderLayout,
  gridGapLayout,
  gridLayout,
  stackedLayout
};
//# sourceMappingURL=grid.js.map
